import React from 'react';
import '../css/Job.css';
import { Link } from 'react-router-dom';

const JobBox = ({job}) => {
  return (
    <Link to={`/jobs/${job.id}`} className='job-box glass' style={{color: job.color==='#ffeb3b'||job.color===''? '#212121' : 'white'}}>
        <div className='job-box-background' style={{backgroundColor:job.color}} />
        <div className='flex gap-3'>
          <div
            className='company-logo'
            style={
              {
                backgroundImage: `url(${job.logo_url || 'https://t3.ftcdn.net/jpg/01/87/10/40/360_F_187104027_8i2JbFDBB5jB7R65Ce464yRs4gfNbR3Z.jpg'})`,
              }
            }/>
          <div>
            <h1 className='font-extrabold text-lg'>
              {job.jobTitle}
            </h1>
            <h3 className='tracking-tight opacity-75'>
              {job.company}
            </h3>
          </div>
        </div>
    </Link>
  )
};
export default JobBox;
